import React from "react";
import Table from "@material-ui/core/Table";
import TableBody from "@material-ui/core/TableBody";
import TableCell from "@material-ui/core/TableCell";
import TableContainer from "@material-ui/core/TableContainer";
import TableHead from "@material-ui/core/TableHead";
import TableRow from "@material-ui/core/TableRow";
import TableFooter from "@material-ui/core/TableFooter";
import Paper from "@material-ui/core/Paper";
import { TableHeader as TableHeaderPDF } from "@david.kucsai/react-pdf-table/lib/TableHeader";
import { TableCell as TableCellPDF } from "@david.kucsai/react-pdf-table/lib/TableCell";
import { TableBody as TableBodyPDF } from "@david.kucsai/react-pdf-table/lib/TableBody";
import { TablePdf } from "../TablePdf/TablePdf";
import { DataTableCell } from "@david.kucsai/react-pdf-table";
import GetCurrency from "../../helper/GetCurrency";

export default function ViewVats(props) {
  let totalExc = 0;
  let totalVat = 0;
  let totalInc = 0;
  let data = [];
  Object.keys(props.vats).forEach((vat) => {
    let incVatAmount = props.vats[vat];
    if (Number.parseFloat(vat) !== 0) {
      incVatAmount = (props.vats[vat] / Number.parseFloat(vat)) * (1 + Number.parseFloat(vat));
    }
    let vatAmount = props.vats[vat];
    let exVatAmount = incVatAmount - vatAmount;
    totalExc += Math.round(exVatAmount);
    totalVat += Math.round(vatAmount);
    totalInc += Math.round(incVatAmount);
    if (!(exVatAmount === 0 && vatAmount === 0 && incVatAmount === 0)) {
      data.push({
        vat: vat,
        exVatAmount: exVatAmount,
        vatAmount: vatAmount,
        incVatAmount: incVatAmount,
      });
    }
  });

  const getPdfView = () => {
    return (
      <TablePdf data={data}>
        <TableHeaderPDF>
          <TableCellPDF weighting={0.2}>Omzet</TableCellPDF>
          <TableCellPDF weighting={0.2} align={"right"}>
            Bedrag exc. btw
          </TableCellPDF>
          <TableCellPDF weighting={0.2} align={"right"}>
            BTW
          </TableCellPDF>
          <TableCellPDF weighting={0.2} align={"right"}>
            Bedrag inc. btw
          </TableCellPDF>
        </TableHeaderPDF>
        <TableBodyPDF>
          <DataTableCell
            weighting={0.2}
            getContent={(r) => {
              return r.vat * 100.0 + "%";
            }}
          />
          <DataTableCell
            weighting={0.2}
            align="right"
            getContent={(r) => {
              return GetCurrency() + ((r.exVatAmount + Number.EPSILON) / 100.0).toFixed(2);
            }}
          />
          <DataTableCell
            weighting={0.2}
            align="right"
            getContent={(r) => {
              return GetCurrency() + ((r.vatAmount + Number.EPSILON) / 100.0).toFixed(2);
            }}
          />
          <DataTableCell
            weighting={0.2}
            align="right"
            getContent={(r) => {
              return GetCurrency() + ((r.incVatAmount + Number.EPSILON) / 100.0).toFixed(2);
            }}
          />
        </TableBodyPDF>
        <TableHeaderPDF>
          <TableCellPDF weighting={0.2}>Totaal</TableCellPDF>
          <TableCellPDF weighting={0.2} align="right">
            {GetCurrency() + ((totalExc + Number.EPSILON) / 100.0).toFixed(2)}
          </TableCellPDF>
          <TableCellPDF weighting={0.2} align="right">
            {GetCurrency() + ((totalVat + Number.EPSILON) / 100.0).toFixed(2)}
          </TableCellPDF>
          <TableCellPDF weighting={0.2} align="right">
            {GetCurrency() + ((totalInc + Number.EPSILON) / 100.0).toFixed(2)}
          </TableCellPDF>
        </TableHeaderPDF>
      </TablePdf>
    );
  };

  props.createPdf(getPdfView());

  return (
    <TableContainer component={Paper}>
      <Table>
        <TableHead>
          <TableRow>
            <TableCell>Omzet</TableCell>
            <TableCell align={"right"}>Bedrag exc. btw</TableCell>
            <TableCell align={"right"}>BTW</TableCell>
            <TableCell align={"right"}>Bedrag inc. btw</TableCell>
          </TableRow>
        </TableHead>
        <TableBody>
          {data.map((r) => {
            return (
              <TableRow key={r.vat}>
                <TableCell>{r.vat * 100.0} %</TableCell>
                <TableCell align="right">
                  {GetCurrency()} {((r.exVatAmount + Number.EPSILON) / 100.0).toFixed(2)}
                </TableCell>
                <TableCell align="right">
                  {GetCurrency()} {((r.vatAmount + Number.EPSILON) / 100.0).toFixed(2)}
                </TableCell>
                <TableCell align="right">
                  {GetCurrency()} {((r.incVatAmount + Number.EPSILON) / 100.0).toFixed(2)}
                </TableCell>
              </TableRow>
            );
          })}
        </TableBody>
        <TableFooter>
          <TableRow>
            <TableCell>Totaal</TableCell>
            <TableCell align="right">
              {GetCurrency()} {((totalExc + Number.EPSILON) / 100.0).toFixed(2)}
            </TableCell>
            <TableCell align="right">
              {GetCurrency()} {((totalVat + Number.EPSILON) / 100.0).toFixed(2)}
            </TableCell>
            <TableCell align="right">
              {GetCurrency()} {((totalInc + Number.EPSILON) / 100.0).toFixed(2)}
            </TableCell>
          </TableRow>
        </TableFooter>
      </Table>
    </TableContainer>
  );
}
